/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/169-hammer2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.784 14.309L7.212 6.505l.399-.4a1.83 1.83 0 00.53-1.181.395.395 0 00.046-.023l1.609-1.006a.676.676 0 00-.036-.898L6.961.191a.673.673 0 00-.896-.036L5.061 1.769l-.022.046c-.43.027-.852.204-1.178.531L2.339 3.873c-.327.327-.503.75-.53 1.181a.395.395 0 00-.046.023L.154 6.083a.676.676 0 00.036.898l2.799 2.806a.673.673 0 00.896.036l1.004-1.614.023-.046c.43-.027.852-.204 1.178-.531l.442-.443 7.783 8.596c.226.249.573.289.773.089l.787-.789c.199-.2.159-.549-.089-.775z"/>'
  }
})
